import { render, staticRenderFns } from "./advItem.vue?vue&type=template&id=75570192&scoped=true&"
import script from "./advItem.vue?vue&type=script&lang=js&"
export * from "./advItem.vue?vue&type=script&lang=js&"
import style0 from "./advItem.vue?vue&type=style&index=0&id=75570192&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75570192",
  null
  
)

export default component.exports